<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.title" />
    </keep-alive>
    <component :is="Component" v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title" />
  </router-view>
</template>
